import React from 'react'

import axios from 'axios'
import downloadFile from 'js-file-download'
import useClipboard from 'react-use-clipboard'

import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import FileService from './../../services/file-service'
import authHeader from './../../services/auth-header'

import file7Zip from './img/icons8-7zip-80.png'
import fileApk from './img/icons8-apk-80.png'
import fileCss from './img/icons8-css-filetype-80.png'
import fileCsv from './img/icons8-csv-80.png'
import fileDmg from './img/icons8-dmg-80.png'
import fileExe from './img/icons8-exe-80.png'
import fileHtml from './img/icons8-html-filetype-80.png'
import fileJson from './img/icons8-json-80.png'
import fileMp3 from './img/icons8-mp3-80.png'
import fileOgg from './img/icons8-ogg-80.png'
import filePdf from './img/icons8-pdf-80.png'
import fileRar from './img/icons8-rar-80.png'
import fileTar from './img/icons8-tar-80.png'
import fileTxt from './img/icons8-txt-80.png'
import fileWav from './img/icons8-wav-80.png'
import fileWord from './img/icons8-word-80.png'
import fileExcel from './img/icons8-xls-80.png'
import fileXml from './img/icons8-xml-file-80.png'
import fileZip from './img/icons8-zip-80.png'
import fileVideo from './img/icons8-video-file-80.png'
import fileBinary from './img/icons8-binary-file-80.png'

const fileTypeImages = {
    '7zip' : file7Zip,
    'apk': fileApk,
    'css': fileCss,
    'csv': fileCsv,
    'dmg': fileDmg,
    'exe': fileExe,
    'html': fileHtml,
    'json': fileJson,
    'mp3': fileMp3,
    'ogg': fileOgg,
    'pdf': filePdf,
    'rar': fileRar,
    'tar': fileTar,
    'txt': fileTxt,
    'wav': fileWav,
    'docx': fileWord,
    'docm': fileWord,
    'dotx': fileWord,
    'docb': fileWord,
    'xls': fileExcel,
    'xlsx': fileExcel,
    'xlsm': fileExcel,
    'xlsb': fileExcel,
    'xltx': fileExcel,
    'xml': fileXml,
    'xaml': fileXml,
    'zip': fileZip,
    'mp4': fileVideo,
    'mov': fileVideo,
    'wmv': fileVideo,
    'avi': fileVideo,
    'flv': fileVideo,
    'f4v': fileVideo,
    'swf': fileVideo,
    'webm': fileVideo,
    'mkv': fileVideo
};

const pictureExtensions = ['png', 'gif', 'jpg', 'jpeg', 'tif', 'svg'];

export default function UploadedFile(props) {
    const data = props.data;
    const extension = data ? data.extension : null;
    const name = data ? data.name : '';
    const url = data ? data.url : '';
    const sizeInBytes = data ? data.sizeInBytes : 0;
    const extensionIsAvailable = extension in fileTypeImages;
    const extensionIsImage = pictureExtensions.includes(extension);
    const extensionIcon = extensionIsAvailable ? fileTypeImages[extension] : fileBinary;

    const [ isCopied, setCopied ] = useClipboard(url, {
        successDuration: 2500
    });
    const [ isDownloading, setIsDownloading ] = React.useState(false);
    const [ previewUrl, setPreviewUrl ] = React.useState(null);

    React.useEffect(() => {
        if (!extensionIsImage || !url) {
            setPreviewUrl(null);
            return;
        }

        let objectUrl = null;
        let isActive = true;

        const loadPreview = async () => {
            try {
                const response = await axios({
                    method: 'GET',
                    url,
                    headers: await authHeader(),
                    responseType: 'blob'
                });

                objectUrl = URL.createObjectURL(response.data);

                if (isActive) {
                    setPreviewUrl(objectUrl);
                } else {
                    URL.revokeObjectURL(objectUrl);
                }
            } catch (error) {
                if (isActive) {
                    setPreviewUrl(null);
                }
            }
        };

        loadPreview();

        return () => {
            isActive = false;

            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [extensionIsImage, url]);

    if (!props.data) {
        return <>
            <Card>
                <Card.Body>
                    <span className="text-danger">Fehler beim Laden</span>
                </Card.Body>
            </Card>
        </>
    }

    const deleteIfCallbackIsPresent = () => {
        if (props.deleteCallback) {
            props.deleteCallback();
        }
    }

    const downloadUploadedFile = async (event) => {
        event.preventDefault();

        setIsDownloading(true);

        try {
            const response = await axios({
                method: 'GET',
                url,
                headers: await authHeader(),
                responseType: 'blob'
            });

            downloadFile(response.data, name, response.headers['content-type']);
        } finally {
            setIsDownloading(false);
        }
    }

    return (
        <>
            <Card className="attachment-card">
                <Card.Body>
                    <Row className="justify-content-md-center mb-4">
                        <Col>
                            <img className={extensionIsImage ? 'attachment-preview' : null} src={extensionIsImage ? previewUrl : extensionIcon} alt="File icon" />
                        </Col>
                    </Row>
                    
                    <Card.Title>{name}</Card.Title>
                    <a href={url} onClick={downloadUploadedFile}>{isDownloading ? 'Lädt herunter...' : 'Herunterladen'}</a>
                    <p className="mb-0">Grösse: {FileService.fileSizeToHumanReadableFormat(sizeInBytes)}<br/>
                    Erstellt vor {FileService.millisecondsToHumanReadableFormat(new Date() - new Date(data.creationTime))}</p>

                    {
                        props.editable ?
                        <div className="mt-2">
                            <Button className="d-block w-100 mb-2" variant="danger" onClick={() => deleteIfCallbackIsPresent()}>Löschen</Button>
                            {
                                extensionIsImage &&
                                <Button className="d-block w-100" onClick={setCopied} disabled={isCopied}>{isCopied ? 'Ist kopiert!' : 'In Zwischenablage kopieren'}</Button>
                            }
                        </div>
                        : null
                    }
                </Card.Body>
            </Card>
        </>
    )
}